"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Service pro tisk štítků a obálek. Generated from cz.marbes.api.dokument.obalky.ObalkaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T22:18:26Z                      #

// ##############################################################

var ObalkaApi = function () {
  function ObalkaApi() {
    (0, _classCallCheck3.default)(this, ObalkaApi);
  }

  (0, _createClass3.default)(ObalkaApi, null, [{
    key: "getSablony",

    /**
     * Vrácí seznam nakonfigurovaných adresních štítků.
     *
     * @return seznam adresních štítků
     */
    value: function getSablony() {
      var uri = serverContextPath + "/api/obalky/sablony";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vytiskne testovací štítek s umělými daty.
     *
     * @param sablonaKod kód šablony
     * @param pageOffset posun tisku
     * @return testovací štítek
     */

  }, {
    key: "zkusebniTisk",
    value: function zkusebniTisk(sablonaKod, pageOffset) {
      var uri = serverContextPath + ("/api/obalky/testovaci/sablona/" + sablonaKod + "/stream");
      var params = { pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Vytiskne adresní údaje podle zadaných metadat a položek.
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @param stitky štítky, které budeme tisknout
     * @param odesilatel odesílatel pro tisk na obálku, při null bude odesílatel nevyplněn
     * @param meta další vlastnosti pro tisk obálek, doplňující a řídící údaje tisku, pokud bude předán {@code null} budou použity prázdné hodnoty
     * @param pageOffset nastavení posunu stránky (vyrovnání chyby podavače), při null bude posun 0 v obou směrech
     * @return Renderované štítky ve formátu PDF
     */

  }, {
    key: "tisk",
    value: function tisk(sablonaKod, stitky, odesilatel, meta, pageOffset) {
      var uri = serverContextPath + ("/api/obalky/sablona/" + sablonaKod + "/stream");
      var params = { odesilatel: odesilatel, meta: meta, pageOffset: pageOffset };
      return (0, _generateUrl2.default)(uri, params, true);
    }

    /**
     * Najde konkrétní šablonu dle kódu.
     *
     * @param sablonaKod kód šablony
     * @return šablona
     */

  }, {
    key: "getObalkaSablonaByKod",
    value: function getObalkaSablonaByKod(sablonaKod) {
      var uri = serverContextPath + ("/api/obalky/sablona/" + sablonaKod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param sablonaKod jednoznačný identifikátor použité šablony
     * @return instance vyplněná dle zvolené šablony
     */

  }, {
    key: "createTiskAdresMetaDefault",
    value: function createTiskAdresMetaDefault(sablonaKod) {
      var uri = serverContextPath + ("/api/obalky/sablona/" + sablonaKod + "/create");
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.post(uri, params, 0, headers));
    }

    /**
     * Vrací testovací stránku.
     *
     * @param pageOffset posun tisku
     * @return testovací stránka
     */

  }, {
    key: "tiskTestovaciStranky",
    value: function tiskTestovaciStranky(pageOffset) {
      var uri = serverContextPath + "/api/obalky/testovaci/stranka/stream";
      var params = {};
      return (0, _generateUrl2.default)(uri, params, true);
    }
  }]);
  return ObalkaApi;
}();

exports.default = ObalkaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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